/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AccountContext, ContextUpdater } from "../../Context";
import { Button, Label } from "reactstrap";
import { requestClientData } from "../../requests/data/Requests";

const Dashboard = () => {
  // contexts
  const contextUpdater = useContext(ContextUpdater);
  const { accountList } = useContext(AccountContext);
  const accountsAvailable = !!accountList?.length;

  // navigator
  const navigate = useNavigate();

  // handlers
  const onSelectClient = (account) => {
    requestClientData({
      context: contextUpdater,
      clientId: account.clientId,
      guestId: account.guestId,
      onSuccess: () => navigate("/data"),
    });
  };

  return (
    <div className="fill-container flex-dynamic d-flex flex-column align-items-center">
      {accountsAvailable ? (
        <>
          <Label className="pt-4 fw-bold" tag="h1">Business List</Label>
          <Label className="pb-2">List of businesses that you have accounts with</Label>
          <div className="d-flex flex-column align-items-center">
            {accountList.map((account, index) => (
              <Button
                key={index}
                className="my-1"
                color="blue"
                size="lg"
                onClick={() => onSelectClient(account)}
              >
                {account.clientName}
              </Button>
            ))}
          </div>
        </>
      ) : (
        <Label className="pt-3" tag="h3">No businesses have your data</Label>
      )}
    </div>
  );
};

export default Dashboard;
